import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Badge, Button } from "react-bootstrap";

const getStatusBadge = (status) => {
  switch (status) {
    case "Pending":
      return "warning";
    case "Approved":
      return "success";
    case "Rejected":
      return "danger";
    case "Cancelled":
      return "dark";
    default:
      return "secondary";
  }
};

const MaterialIssueItem = ({
  items,
  onView,
  onCancel,
  currentUser,
  totalItems,
  totalPages,
  currentPage,
  itemsPerPage,
  goToPage,
  isStart,
  isEnd,
  getNext,
  getPrev,
}) => {
  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table mb-0 table-striped">
                  <thead>
                    <tr>
                      <th>Request No</th>
                      <th>Material Type</th>
                      <th>Item Name</th>
                      <th>Details</th>
                      <th>Reason</th>
                      <th>Qty</th>
                      <th>Requester</th>
                      <th>Date</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody id="items-table">
                    {items.map((item) => {
                      const requestedAt = item.requestedAt
                        ? item.requestedAt.toDate
                          ? item.requestedAt.toDate()
                          : new Date(item.requestedAt)
                        : null;

                      return (
                        <tr key={item.id} className="btn-reveal-trigger">
                          <td className="py-2">{item.requestNo}</td>
                          <td className="py-2">{item.materialType}</td>
                          <td className="py-2">{item.itemName}</td>
                          <td className="py-2">{item.itemDetails}</td>
                          <td className="py-2" style={{ maxWidth: "220px" }}>
                            <div
                              className="text-truncate"
                              style={{ maxWidth: "220px" }}
                              title={item.reason || ""}
                            >
                              {item.reason || "-"}
                            </div>
                          </td>
                          <td className="py-2">{item.quantity}</td>
                          <td className="py-2">{item.requestedBy}</td>
                          <td className="py-2">
                            {requestedAt
                              ? requestedAt.toLocaleDateString("th-TH", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                })
                              : "-"}
                          </td>
                          <td className="py-2">
                            <Badge variant={getStatusBadge(item.status)}>
                              {item.status}
                            </Badge>
                          </td>
                          <td className="py-2 text-right">
                            <div className="d-flex">
                              <Link
                                className="btn btn-info shadow btn-xs sharp mr-2"
                                to="#"
                                onClick={() => onView(item.id)}
                                data-toggle="tooltip"
                                data-placement="top"
                                title="View details"
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                              {item.status === "Pending" &&
                                currentUser &&
                                (currentUser.email === item.requestedByEmail ||
                                  currentUser.displayName === item.requestedBy) && (
                                  <Link
                                    className="btn btn-warning shadow btn-xs sharp"
                                    to="#"
                                    onClick={() => onCancel(item.id)}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Cancel request"
                                  >
                                    <i className="fa fa-ban"></i>
                                  </Link>
                                )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {totalPages > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="dataTables_info">
                    Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                    {totalItems < currentPage * itemsPerPage
                      ? totalItems
                      : currentPage * itemsPerPage}{" "}
                    of {totalItems} entries
                  </div>
                  <div className="d-flex align-items-center">
                    <Button
                      variant="outline-primary"
                      disabled={isStart}
                      onClick={getPrev}
                      className="mr-2"
                    >
                      Previous
                    </Button>
                    <div className="d-flex">
                      {Array.from(
                        { length: Math.min(5, totalPages) },
                        (_, i) => {
                          const pageNum = Math.max(1, currentPage - 2) + i;
                          if (pageNum <= totalPages) {
                            return (
                              <Button
                                key={pageNum}
                                variant={
                                  pageNum === currentPage
                                    ? "primary"
                                    : "outline-primary"
                                }
                                size="sm"
                                className="mx-1"
                                onClick={() => goToPage(pageNum)}
                              >
                                {pageNum}
                              </Button>
                            );
                          }
                          return null;
                        },
                      )}
                    </div>
                    <Button
                      variant="outline-primary"
                      disabled={isEnd}
                      onClick={getNext}
                      className="ml-2"
                    >
                      Next
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MaterialIssueItem;
